import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import contactUsBanner from '../../assets/andimar/andimar-contact-banner.jpg';
import { AndimarTitle } from '../../common/Title/AndimarTitle';
import contactBy1 from '../../assets/andimar/contact-by/contact.svg';
import contactBy2 from '../../assets/andimar/contact-by/email.svg';
import contactBy3 from '../../assets/andimar/contact-by/location.svg';
import socialMedia1 from '../../assets/andimar/social-media/fb.png';
import socialMedia2 from '../../assets/andimar/social-media/insta.png';
import ContactForm4 from '../../common/contact/ContactForm4';
import CommonService from '../../../../services/commonService';
import KuposHelmet from '../../../common/KuposHelmet';
import { AppData } from '../../../../services';

const contactByArr = [
  {
    text: '(+562) 2683 8528 // (+56 9) 4915 6683',
    image: '/assets/andimar/social-media/whatsapp.png',
  },
  {
    text: 'ayuda@pasajebus.com',
    image: contactBy2,
  },
  {
    text: `Compañía 4368 - Quinta Normal.
    Santiago, Región Metropolitana.`,
    image: contactBy3,
  },
];

const socialMedia = [
  { icon: socialMedia1, link: 'https://www.facebook.com/NuevaAndimarVIP' },
  {
    icon: socialMedia2,
    link:
      'https://www.instagram.com/andimarvip/?utm_source=ig_embed&ig_mid=327903A9-8631-4919-BB95-D5083ADB2AAD&hl=es',
  },
];

const AndimarContactUs = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

		// contactByArr[0].text = operator && operator.phone_number 
	 contactByArr[1].text = operator && operator.email 

  return (
    <div className="montserrat-bold">
      <KuposHelmet />
      <HeroSection
        heroImage={contactUsBanner}
        height={'41vh'}
        title={'Contacto'}
        description={'Home / Contacto'}
        marginTop="-70px"
      />

      <div className="new-container">
        <AndimarTitle title={'CONTACTO'} />
        <div className="contact-us d-flex my-5">
          <ContactForm4 operator={operator} showMap props={props} andimar={true} />

          <div className="contact-by w-50 d-flex justify-center align-items-start flex-column ">
            {contactByArr.map((item, key) => (
              <div className="contact-by-item d-flex">
                <img src={item.image} alt="" style={{ width: '40px' }} />
                <span className="lh-1-3 " style={{ fontWeight: 'bold', fontSize: '13px' }}>
                  {item.text}
                </span>
              </div>
            ))}
            <div className="social-media">
              <div
                // className="font13 montserrat"
                style={{
                  color: operator.theme_color2 && operator.theme_color2,
                  marginBottom: 10,
                  fontWeight: 'bold',
                  fontSize: '16px',
                }}
              >
                SÍGUENOS EN REDES SOCIALES
              </div>
              <div>
                {socialMedia.map(item => (
                  <a href={item.link} target="_blank">
                    <img src={item.icon} alt="" />
                  </a>
                ))}
              </div>
            </div>
            {/* <div
              style={{
                textAlign: 'center',
                fontSize: '13px',
                lineHeight: 1.3,
                margin: 30,
                fontWeight: 'bolder',
              }}
            >
              <div style={{ textAlign: 'center', marginLeft: 50 }}>
                Para reclamos, sugerencias o felicitaciones te invitamos a acceder a nuestro sistema
                de Servicio al Cliente aquí
              </div>
            </div> */}
            {/* <a
              href="#"
              target="_blank"
              style={{ fontSize: '15px' }}
              className="andimar-btn-link less-bold-text"
            >
              Ingresa al sistema Aquí
            </a> */}
            <div
              style={{
                textAlign: 'center',
                fontSize: '13px',
                lineHeight: 1.3,
                margin: 30,
                fontWeight: 'bolder',
              }}
            >
              <div style={{ textAlign: 'center', marginLeft: 70 }}>
                En caso de problemas con compras en línea, envía tu solicitud a{" "}
                <span style={{ color: operator.theme_color2 && operator.theme_color2 }}>
                  {operator && operator.email}{' '}
                  
                </span>
                o comunícate al
                <br />{' '}
                <span style={{ color: operator.theme_color2 && operator.theme_color2 }}>
																{operator && operator.phone_number}{' '}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AndimarContactUs);



// WEBPACK FOOTER //
// ./src/features/themes/themes1/AndimarPages/AndimarContactUs.js